import { Flex, Skeleton } from '@chakra-ui/react';
import { useResource } from 'datx-jsonapi-react';
import { FC, useState } from 'react';

import { VotingForm } from '@/components/ui/features/events-app/event/EventContent/components/VotingForm';
import { VotingSuccess } from '@/components/ui/features/events-app/event/EventContent/components/VotingSuccess';
import { queryLectureVote } from '@/queries/lecture-votes';
import { ThinLecture } from '@/resources/ThinLecture';

interface IVotingContentProps {
  lecture: ThinLecture;
}

export const VotingContent: FC<IVotingContentProps> = ({ lecture }) => {
  const [changeVote, setChangeVote] = useState<boolean>(false);
  const { data: vote, isValidating, error } = useResource(queryLectureVote(lecture.id));

  if (isValidating && !error)
    return (
      <Flex justifyContent="center" mt={10}>
        <Skeleton height="300px" width="400px" />
      </Flex>
    );

  if (!vote || (vote && changeVote)) return <VotingForm setChangeVote={setChangeVote} vote={vote} lecture={lecture} />;

  return <VotingSuccess setChangeVote={setChangeVote} />;
};
